import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const uploadAwardExecutiveSummaryFileTemplate: (
  fetchContext: FetchContext,
  awardId: number,
  documentContent: File,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardId, documentContent, accessToken) => {
  const formData = new FormData();
  formData.append('executiveSummaryFileUploadRequest', documentContent);

  return fetch(`${fetchContext.baseUrl}/api/awards/${awardId}/executive-summary-file-template`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'upload award executive summary file template'));
};
